import styles from "./postShift.module.css";
import {
    createFormField,
    createSelectorField,
    createDateTimeField,
} from "../formfield/sharedFormFields";

interface FormFieldProps {
    label: string;
    icon?: React.ReactNode;
    error?: string;
    children: React.ReactNode;
    controlId?: string;
}

export const FormField = createFormField(
    {
        formGroup: `${styles.formGroup} ${styles.formGroupSelect}`,
        labelWrapper: `${styles.formGrid} ${styles.formGridIconCols}`,
        label: styles.formLabel,
        errorMessage: styles.errorMessage,
    },
    true,
) as React.FC<FormFieldProps>;

export const SelectorField = createSelectorField(
    FormField,
    {
        selectSx: {
            height: "auto",
            minHeight: "2.75rem",
            borderRadius: "calc(var(--radius) - 0.125rem)",
            backgroundColor: '#fff',
            boxShadow: 'none',
            '& .MuiSelect-select': {
                paddingTop: '8px',
                paddingBottom: '8px',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: '1px solid var(--color-border)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                border: '1px solid var(--color-border)',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                border: '1px solid var(--color-border)',
            },
        },
        menuPropsSx: {
            maxHeight: 300,
            '& .MuiMenuItem-root': {
                minHeight: '36px',
                paddingTop: '6px',
                paddingBottom: '6px',
            },
            '& .MuiMenuItem-root.Mui-selected': {
                backgroundColor: 'rgba(0, 0, 0, 0.08)',
                '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.12)',
                },
            },
            '& .MuiMenuItem-root:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
        },
        muiSelectorSx: {
            height: "2.75rem",
            borderRadius: "calc(var(--radius) - 0.125rem)",
            border: "1px solid var(--color-border)",
            boxShadow: 'none',
            '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
            '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
        },
    },
);

export const DateTimeField = createDateTimeField(
    {
        formGroup: styles.formGroup,
        timeHeaderWrapper: styles.timeHeaderWrapper,
        labelWrapper: `${styles.formGrid} ${styles.formGridIconCols}`,
        label: styles.formLabel,
        errorMessage: styles.errorMessage,
    },
    (icon) => (icon ? { marginLeft: '-0.75rem' } : undefined),
);